import { createRouter, createWebHistory } from 'vue-router'
import Login from '../pages/Login.vue'
import MenuModern from '../pages/MenuModern.vue'
import Dashboard from '@/pages/Dashboard.vue'
import RelatorioFiltroOriginal from '@/pages/RelatorioFiltroOriginal.vue'
import RelatorioDetalhado from '@/pages/RelatorioDetalhado.vue'
import Configuracoes from '@/pages/Configuracoes.vue'
import SistemaLogs from '@/pages/SistemaLogs.vue'
import AccessLogs from '@/pages/AccessLogs.vue'

const routes = [
  {
    path: '/',
    redirect: '/login'
  },
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/menu',
    component: MenuModern,
    meta: { requiresAuth: true },
    children: [
      {
        path: '',
        redirect: 'dashboard'
      },
      {
        path: 'dashboard',
        name: 'Dashboard',
        component: Dashboard,
        meta: { requiresAuth: true }
      },
      {
        path: 'relatorios',
        name: 'Relatorios',
        component: RelatorioFiltroOriginal,
        meta: { requiresAuth: true }
      },
      {
        path: 'relatorio-detalhado',
        name: 'RelatorioDetalhado',
        component: RelatorioDetalhado,
        meta: { requiresAuth: true }
      },
      {
        path: 'configuracoes',
        name: 'Configuracoes',
        component: Configuracoes,
        meta: { requiresAuth: true }
      },
      {
        path: 'sistema-logs',
        name: 'SistemaLogs',
        component: SistemaLogs,
        meta: { requiresAuth: true, requiresAdmin: true }
      },
      {
        path: 'access-logs',
        name: 'AccessLogs',
        component: AccessLogs,
        meta: { requiresAuth: true, requiresAdmin: true }
      }
    ]
  },
  {
    path: '/dashboard',
    redirect: '/menu/dashboard'
  },
  {
    path: '/relatorios',
    redirect: '/menu/relatorios'
  },
  {
    path: '/relatorio-detalhado',
    redirect: '/menu/relatorio-detalhado'
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

// Verificação de autenticação e permissões
router.beforeEach((to, from, next) => {
  const isAuthenticated = localStorage.getItem('user') !== null
  const userName = localStorage.getItem('user_name') || ''
  const isAdmin = localStorage.getItem('is_admin') === 'true'
  const isTabosa = userName === 'tabosa'
  
  // Verificar se a rota requer autenticação
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!isAuthenticated) {
      next('/login')
      return
    }
    
    // Verificar se a rota requer admin ou tabosa
    if (to.matched.some(record => record.meta.requiresAdmin)) {
      if (!isAdmin && !isTabosa) {
        next('/menu') // Redirecionar para menu se não for admin nem tabosa
        return
      }
    }
  }
  
  next()
})

export default router
